<template>
  <div class="product-collect-component"
       :class="[{
         'is-bottom': position === 'bottom',
         'is-top': position === 'top',
         'is-collected': collected,
         }]"
       @click="handleClick"
  >
    <ym-icon class="product-collect-icon"
             :name="statusMap"
    />
    <div class="product-collect-desc">{{ textMap }}</div>
  </div>
</template>

<script>
  import { toggleMyCollect } from '@/services/user';

  export default {
    name: 'ProductCollect',
    props: {
      targetType: {
        type: String,
        required: true,
      },
      targetId: {
        type: Number,
        required: true,
      },
      status: {
        type: String,
        required: true,
        validator(val) {
          return [
            'collected',
            'collect',
          ].includes(val);
        },
      },
      position: {
        type: String,
        default: 'top',
      },
    },
    data() {
      return {
        disabled: false,
        collected: false,
      };
    },
    watch: {
      status(val) {
        this.setCollected(val);
      },
    },
    computed: {
      statusMap() {
        return this.collected ? 'collected' : 'collect';
      },
      textMap() {
        return this.collected ? '已收藏' : '收藏';
      },
    },
    methods: {
      setCollected(status) {
        this.collected = status === 'collected';
      },
      async handleClick() {
        const {
          disabled, targetType, targetId, collected,
        } = this;
        if (disabled) return;
        this.disabled = true;
        const collectAction = Number(!collected);
        try {
          await toggleMyCollect(targetType, targetId, collectAction);
          this.collected = !this.collected;
          this.disabled = false;
        } catch (e) {
          this.disabled = false;
        }
      },
    },
    created() {
      this.setCollected(this.status);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-collect-component {
    display: flex;
    align-items: center;
    justify-content: center;

    &.is-bottom {
      flex-basis: @trail-program-size;
      flex-direction: column;
      color: @color-text-base;
      font-size: @font-size-extra-small;
      line-height: 1;
      .product-collect-icon {
        font-size: 40px;
        margin-bottom: @size-extra-small / 2;
      }
    }
    &.is-top {
      box-sizing: border-box;
      padding: 0 24px;
      height: 50px;
      color: @color-text-lighter;
      font-size: @font-size-base;
      line-height: 1;
      border: 1px solid @color-text-lighter;
      border-radius: 25px;
      .product-collect-icon {
        font-size: 30px;
        margin-right: @size-extra-small;
        margin-bottom: 2px;
      }
    }
    &.is-collected {
      .product-collect-icon {
        color: @color-primary;
      }
    }
  }
</style>
